import type {ReactNode} from 'react';

export type PropsWithChildren = {
  children?: ReactNode;
};

export enum SizeTokenValue {
  XLarge = 'XLarge',
  Large = 'large',
  Medium = 'medium',
  Small = 'small',
  XSmall = 'XSmall',
  XXSmall = 'XXSmall',
}

export enum Placement {
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
  Left = 'left',
  TopStart = 'top-start',
  TopEnd = 'top-end',
  RightStart = 'right-start',
  RightEnd = 'right-end',
  BottomStart = 'bottom-start',
  BottomEnd = 'bottom-end',
  LeftStart = 'left-start',
  LeftEnd = 'left-end',
}
